<template>
  <div class="actions">
    <el-radio-group v-model="valueSync" class="actions__input">
      <el-radio-button :label="false">{{ labelsObject.falseLabel }}</el-radio-button>
      <el-radio-button :label="true">{{ labelsObject.trueLabel }}</el-radio-button>
    </el-radio-group>
    <p class="actions__text" v-if="labelsObject.textLabel">
      {{ labelsObject.textLabel }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'serviceBooleanAction',
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    labels: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    valueSync: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    labelsObject() {
      return {
        trueLabel: this.$t('base.yes'),
        falseLabel: this.$t('base.no'),
        textLabel: '',
        ...this.labels,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.actions {
  padding: 20px;
  background-color: var(--nxt-color-light-grey);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  @include breakpoint(desktop) {
    flex-direction: row;
  }
  &__input {
    margin: auto 20px auto 0;
  }
  &__text {
    flex: 1;
    margin: 0;
    font-size: 20px;
    display: flex;
    align-items: center;
  }
}
</style>
